import * as stylex from '@stylexjs/stylex';
import { MdHowToReg } from 'react-icons/md';
import { shared } from '~styles';
import { styles } from './styles';
export function Capacity({
  count,
  max
}: {
  count: number;
  max: number;
}) {
  const full = count >= max;
  const pct = max > 0 ? Math.min(100, Math.round(count / max * 100)) : 0;
  return <section {...stylex.props(shared.card)}>
      <div {...stylex.props(styles.topRow)}>
        <div {...stylex.props(styles.left)}>
          <MdHowToReg size={20} {...stylex.props(styles.icon)} />
          <span {...stylex.props(styles.label)}>Going</span>
        </div>
        <span {...stylex.props(styles.count)}>
          {count}<span {...stylex.props(styles.total)}> / {max}</span>
        </span>
      </div>
      <div {...stylex.props(styles.track)}>
        <div {...stylex.props(styles.fill, full && styles.fillFull)} style={{
        width: `${pct}%`
      }} />
      </div>
    </section>;
}